$(function () {
  $(document).on('click', '.ajax_add_to_cart', function (event) {
    event.preventDefault();
    const form = $(this).closest('.js-product-form');
    const id = form.find('.js-all-variants').val();
    const qty = form.find('[name="quantity"]').val();
    let selling_plan = null;
    if (form.find(".js-subscr-box.active").data('subscr') === true && form.find('.js-plan-selector')) {
      selling_plan = form.find('.js-plan-selector').val();
    }
    addItemToCart(id, qty, selling_plan);
  });
  function addItemToCart(variant_id, qty, selling_plan) {
    CartJS.addItem(variant_id, qty, {
      // should trigger update and cart drawer
      selling_plan: selling_plan,
    });
  }

  // function addItemToCart(variant_id, qty, selling_plan) {
  //   var rc_status = $(".rc_container_wrapper").length > 0 ? true : false;
  //   var rc_checked_status = $(".rc_widget__option__input--onetime").is(
  //     ":checked"
  //   );

  //   if (rc_status && !rc_checked_status) {
  //     var selling_plan = $(".rc-selling-plans__dropdown").val();
  //   } else {
  //     var selling_plan = null;
  //   }

  //   CartJS.addItem(variant_id, qty, {
  //     // should trigger update and cart drawer
  //     selling_plan: selling_plan,
  //   });
  // }
  
  var config = {
    body: $("body"),
    sticky_block: $(".mobile-add-to-cart-overlay") || null,
    element_position:
      $(".pdp_accordion_main").length > 0
        ? $(".pdp_accordion_main").offset().top
        : null,
    screen_height: $(window).height(),
    activation_offset: -0.42, //determines how far up the the page the element needs to be before triggering the function
    rc_widget: $(".rc-option__subsave") || null,
    discountOverride: window.siteDiscount == "true" ? true : false,
    discountAmount: window.siteDiscountAmount ? window.siteDiscountAmount : 0,
  };
  

  var activation_point =
      config.element_position - config.screen_height * config.activation_offset,
    max_scroll_height = config.body.height() - config.screen_height - 5;

  $(window).on("scroll", function () {
    var y_scroll_pos = window.pageYOffset,
      element_in_view = y_scroll_pos > activation_point,
      has_reached_bottom_of_page =
        max_scroll_height <= y_scroll_pos && !element_in_view;

    element_in_view || has_reached_bottom_of_page
      ? show_add_to_cart(true)
      : show_add_to_cart(false);
  });

  function show_add_to_cart(conditional) {
    var rc_status = $(".rc_container_wrapper").length > 0 ? true : false;
    rc_status ? update_sticky_add_to_cart() : null;
    conditional
      ? config.sticky_block.addClass("active_view")
      : config.sticky_block.removeClass("active_view");
  }

  function update_sticky_add_to_cart() {
    $(".rc_widget__option__input--onetime").is(":checked")
      ? sticky_one_time()
      : null;
    $(".rc_widget__option__input--subsave").is(":checked")
      ? sticky_subscription()
      : null;
  }

  function sticky_one_time() {
    $(".sticky_frequency").text("");
    $(".sticky_price").text($(".rc_widget__price--onetime").text());
  }

  function sticky_subscription() {
    var frequency = $(".rc-selling-plans__dropdown")
      .find(":selected")
      .text()
      .replace("Delivery every ", "");
    $(".sticky_frequency").text(`/ ${frequency}`);
    $(".sticky_price").text($(".rc_widget__price--subsave").text());
  }



  /**
   * Wait for an element before resolving a promise
   * @param {String} querySelector - Selector of element to wait for
   * @param {Integer} timeout - Milliseconds to wait before timing out, or 0 for no timeout
   */
  function waitForElement(querySelector, timeout) {
    return new Promise((resolve, reject) => {
      var timer = false;
      if (document.querySelectorAll(querySelector).length) return resolve();
      const observer = new MutationObserver(() => {
        if (document.querySelectorAll(querySelector).length) {
          observer.disconnect();
          if (timer !== false) clearTimeout(timer);
          return resolve();
        }
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
      if (timeout)
        timer = setTimeout(() => {
          observer.disconnect();
          reject();
        }, timeout);
    });
  }

  if (window.location.href.indexOf("product") > -1) {
    var discountDecimal = config.discountAmount / 100;
    var prodPrice = (prodPrice = parseFloat(productCartConfig?.product_price));
    var prodDiscount = parseFloat(prodPrice * discountDecimal);
    var prodDiscountPrice = parseFloat(prodPrice - prodDiscount);
    var prodDiscountPrice = parseFloat(prodDiscountPrice / 100);
    var pricingElm = `
   <span class="product__price price-discount" style="display:inline-flex">
   <span class="compare-at-price" style="opacity:1">
     <del> $ ${(prodPrice / 100).toFixed(2)}</del>
   </span>
   <span class="live-price color-7A9E55" style="color:#7A9E55">
    $ ${prodDiscountPrice.toFixed(2)}
   </span>
 </span>`;
  }

  $(".quick_atc_add_to_cart").click(function (event) {
    event.preventDefault();
    $(this).find(".sub_btntxt").hide();
    $(this).find(".lds-ring").css("display", "inline-block");
    var id = $(this).attr("data-input");
    // addItemToCart(id, 1, 123);
    addItemToCart(id, 1, '');
    show_add_to_cart(true);

    setTimeout(() => {
      $(this).find(".lds-ring").hide();
      $(this).find(".sub_btntxt").show();
      $(this).find(".sub_btntxt").text("Added!");
    }, 800);

    setTimeout(() => {
      $(this).find(".sub_btntxt").text("Add to Cart");
    }, 1600);
  });



  config.body.on(
    "click",
    ".customAfterpayBtn, .customShopBtn",
    function (event) {
      event.preventDefault();

      if ($(this).hasClass("customAfterpayBtn")) {
        var afterPayBtn = document
          .querySelector("afterpay-placement")
          .shadowRoot.querySelector(".afterpay-logo");
        afterPayBtn.click();
      }

      if ($(this).hasClass("customShopBtn")) {
        var shopPayBtn = document
          .querySelector("shopify-payment-terms")
          .shadowRoot.querySelector("shop-pay-installments-banner")
          .shadowRoot.querySelector("#shopify-installments-cta");
        shopPayBtn.click();
      }
    }
  );

  config.body
    .on("change", ".rc-radio", function () {
      var rc_status = $(".rc_container_wrapper").length > 0 ? true : false;
      console.log("widget change");
      rc_status ? update_sticky_add_to_cart() : null;

      setTimeout(() => {
        config.discountOverride == true
          ? $(
              ".rc-option__price.rc_widget__price.rc_widget__price--onetime"
            ).html(pricingElm)
          : null;
        config.discountOverride == true
          ? $(".add_spce").html(pricingElm)
          : null;
      }, 300);
    })
    .change();

  if (config.discountOverride == true) {
    waitForElement(
      ".rc-option__price.rc_widget__price.rc_widget__price--onetime",
      0
    )
      .then(function () {
        setTimeout(() => {
          $(
            ".rc-option__price.rc_widget__price.rc_widget__price--onetime"
          ).html(pricingElm);
        }, 1000);
      })
      .catch(() => {
        //  console.log("element did not load in 3 seconds");
      });
  }

  config.sticky_block.click(function () {
    console.log('click');
    $(".subscription-add")[0].click();
    return false;
  });
});